import { SET_PRO, SET_STORE } from '../constants/index';
import { ProState, ProActions } from '../types/proTypes'

const initialState: ProState = {
  loading: false,
  expired: false,
  storeReady: false,
  owned: false,
  title: '',
  price: '',
  currency: '',
  description: '',
  type: '',
  expiryDate: undefined,
  lastRenewalDate: undefined
}

const proReducer = (state = initialState, action: ProActions) => {
  const payload = action.payload
  switch(action.type){

    case SET_PRO:
      return {
        ...state,
        loading: payload.loading,
        expired: payload.expired,
        owned: payload.owned,
        title: payload.title,
        price: payload.price,
        currency: payload.currency,
        description: payload.description,
        type: payload.type,
        expiryDate: payload.expireDate,
        lastRenewalDate: payload.lastRenewalDate
      }

    case SET_STORE:
      return {
        ...state,
        storeReady: payload
      }
    
    default: 
      return state
  }
}

export default proReducer;